/* eslint-disable */
import React, { useState } from 'react';
import {
  addMonths,
  isSameDay,
  isWithinInterval,
  isAfter,
  isBefore,
  isSameMonth,
  addYears,
  max,
  min,
} from 'date-fns';
import { getValidatedMonths, parseOptionalDate } from './dateFormatUtils';
import { defaultRanges } from './defaultsPresetter';
import Menu from './customCalender';
import PropTypes from 'prop-types';

export const MARKERS = {
  FIRST_MONTH: Symbol('firstMonth'),
  SECOND_MONTH: Symbol('secondMonth'),
};

const DateRangePicker = (props) => {
  const today = new Date();

  const {
    open,
    onChange,
    initialDateRange,
    minDate,
    maxDate,
    definedRanges = defaultRanges,
  } = props;

  const minDateValid = parseOptionalDate(minDate, addYears(today, -50));
  const maxDateValid = parseOptionalDate(maxDate, addYears(today, 50));

  const [initialFirstMonth, initialSecondMonth] = getValidatedMonths(
    initialDateRange || {},
    minDateValid,
    maxDateValid,
  );

const [dateRange, setDateRange] = useState(initialDateRange || defaultRanges.find(range => range.label === 'Last 2 Months'));
  const [hoverDay, setHoverDay] = useState(null);
  const [firstMonth, setFirstMonth] = useState(initialFirstMonth || today);
  const [secondMonth, setSecondMonth] = useState(
    initialSecondMonth || addMonths(firstMonth, 1),
  );

  const { startDate, endDate } = dateRange;
  const isCustomRange = dateRange.label === 'Custom';

  const setFirstMonthValidated = (date) => {
    if (isBefore(date, secondMonth)) {
      setFirstMonth(date);
    }
  };

  const setSecondMonthValidated = (date) => {
    if (isAfter(date, firstMonth)) {
      setSecondMonth(date);
    }
  };

  const setDateRangeValidated = (range) => {
    let { startDate: newStart, endDate: newEnd } = range;

    if (newStart && newEnd) {
      if (isAfter(newStart, newEnd)) {
        [newStart, newEnd] = [newEnd, newStart];
      }
      range.startDate = max([newStart, minDateValid]);
      range.endDate = min([newEnd, maxDateValid]);
      setDateRange(range);
      onChange(range);

      setFirstMonth(newStart);
      setSecondMonth(
        isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd,
      );
    } else {
      setDateRange({});
      onChange({});

      setFirstMonth(today);
      setSecondMonth(addMonths(firstMonth, 1));
    }
  };

  const onDayClick = (day) => {
    if (isCustomRange) {
      if (startDate && !endDate && !isBefore(day, startDate)) {
        const newRange = { startDate, endDate: day };
        setDateRange(newRange);
        onChange(newRange);
      } else {
        setDateRange({ startDate: day, endDate: undefined });
      }
      setHoverDay(day);
    }
  };

  const onDayHover = (date) => {
    if (isCustomRange && startDate && !endDate) {
      if (!hoverDay || !isSameDay(date, hoverDay)) {
        setHoverDay(date);
      }
    }
  };

  const inHoverRange = (day) =>
    isCustomRange && startDate && !endDate && hoverDay && isAfter(hoverDay, startDate) &&
    isWithinInterval(day, {
      start: startDate,
      end: hoverDay,
    });

  const helpers = {
    inHoverRange,
  };

  const handlers = {
    onDayClick,
    onDayHover,
    onMonthNavigate,
  };

  const onApply = () => {
    setDateRange({ ...dateRange });
    onChange({ ...dateRange });
  };
  

  const onCancel = () => {
    setDateRange({});
    onChange({});
  };

  const onCustomSelect = () => {
    setDateRange({ startDate: null, endDate: null, label: 'Custom' });
    setHoverDay(null);
    
  };

  return open ? (
    <Menu
      dateRange={dateRange}
      minDate={minDateValid}
      maxDate={maxDateValid}
      ranges={definedRanges}
      firstMonth={firstMonth}
      secondMonth={secondMonth}
      setFirstMonth={setFirstMonthValidated}
      setSecondMonth={setSecondMonthValidated}
      setDateRange={setDateRangeValidated}
      helpers={helpers}
      handlers={handlers}
      onCancel={onCancel}
      onApply={onApply}
      onCustomSelect={onCustomSelect}
    />
  ) : null;
};
DateRangePicker.propTypes = {
  open: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  initialDateRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  definedRanges: PropTypes.array,
};


export default DateRangePicker;

